export enum UserListType {
    Keyword = 'keyword-list',
    Anchor =  'anchor-search',
    Backlink = 'backlink-search',
    LinkIntersect = 'link-intersect-search',
    ReferringDomains = 'referring-domain-search',
}

export enum KeywordListType {
    Related = 'relatedKeywords',
    Suggestions = 'keywordSuggestions',
    Ideas =  'keywordIdeas',
    AmazonRelated = 'amazonRelatedKeywords',
}
